var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isActualRouteName)?_c('img',{attrs:{"src":require("@/assets/main-unselected.svg")}}):_c('img',{attrs:{"src":require("@/assets/main-selected.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }